/**
 * Pill-shaped toggle button used in filter chip strips. The active state
 * inverts (bg-foreground / text-background) so the selected scope reads
 * clearly against the page background. Originally from the Activity page;
 * lifted here so other filter surfaces (Inbox, etc.) stay visually aligned.
 */
export function FilterChip({
  active,
  onClick,
  children,
}: {
  active: boolean;
  onClick: () => void;
  children: React.ReactNode;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={active}
      className={`inline-flex items-center rounded-full px-3 py-1 text-xs font-medium border transition-colors ${
        active
          ? 'bg-foreground text-background border-foreground'
          : 'bg-background text-foreground border-border hover:bg-accent'
      }`}
    >
      {children}
    </button>
  );
}
